import { MonthlyThemePage } from "../core/interfaces/MonthlyTheme";
import ProviderFactory from "../core/ProviderFactory";
import OcontentMonthlyThemeProvider from "../core/providers/ocontent/OcontentMonthlyThemeProvider";
import {
  OcontentProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";

export default abstract class MonthlyThemeModel {
  static monthlyThemeCache: Map<string, MonthlyThemePage> = new Map();
  private static monthlyThemeProvider: OcontentMonthlyThemeProvider =
    ProviderFactory.create(
      OcontentProviderType.MonthlyTheme,
      ProviderConfiguration.ocontent
    );

  public static async getPage(
    pageName: string
  ): Promise<MonthlyThemePage | null> {
    if (!MonthlyThemeModel.monthlyThemeCache.has(pageName)) {
      const page = await MonthlyThemeModel.monthlyThemeProvider.getPage(
        pageName
      );
      MonthlyThemeModel.monthlyThemeCache.set(pageName, page);
    }
    return MonthlyThemeModel.monthlyThemeCache.get(pageName);
  }
}
